import { useState } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchPublisherPrefixes } from "../api/publisherPrefixService";
import { DEFAULT_PAGE_SIZE } from "../utils/constants";
export var usePublisherPrefixData = function (appliedFilters, buildQuery, isQueryReady, pageSize) {
    var _a;
    if (pageSize === void 0) { pageSize = DEFAULT_PAGE_SIZE; }
    var ky = useOkapiKy();
    var _b = useState(0), pageOffset = _b[0], setPageOffset = _b[1];
    var _c = useState(0), totalRecords = _c[0], setTotalRecords = _c[1];
    var query = buildQuery(appliedFilters);
    var _d = useQuery(["publisher-prefixes", appliedFilters, pageOffset, pageSize], function () {
        return fetchPublisherPrefixes(ky, {
            query: query,
            offset: pageOffset,
            limit: pageSize,
        });
    }, {
        keepPreviousData: true,
        enabled: isQueryReady,
        onSuccess: function (d) { var _a; return setTotalRecords((_a = d.totalRecords) !== null && _a !== void 0 ? _a : 0); },
    }), data = _d.data, isLoading = _d.isLoading, isError = _d.isError;
    var itemsData = (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [];
    var fetchMoreData = function (offset) {
        setPageOffset(offset);
    };
    var resetPageOffset = function () { return setPageOffset(0); };
    return {
        itemsData: itemsData,
        totalRecords: totalRecords,
        isLoading: isLoading,
        isError: isError,
        fetchMoreData: fetchMoreData,
        resetPageOffset: resetPageOffset,
        pageOffset: pageOffset,
        pageSize: pageSize,
    };
};
